export default "__VITE_ASSET__BU3CLy2M__"